import { z } from 'zod';

const itemSchema = z.object({
	value: z.string(),
	label: z.string()
});

export const editProcessObjectSchema = z.object({
	cx: z.number().min(0, 'cX must be a positive number'),
	cy: z.number().min(0, 'cY must be a positive number'),
	timeAdjustment: z.number({
		required_error: 'Time adjustment is required',
		invalid_type_error: 'Time adjustment must be a number'
	}),
	trmsLimit: z.number().min(0, 'TRMS Limit must be a positive number'),
	voltage: z.array(itemSchema).nonempty('Voltage is required'),
	primaryTtms: z.array(itemSchema).nonempty('Primary TTMS is required'),
	secondaryTtms: z.array(itemSchema).nonempty('Secondary TTMS is required'),
	algorithm: z.array(itemSchema).nonempty('Algorothmis required')
});

export type EditProcessObjectFormSchema = z.infer<typeof editProcessObjectSchema>;
